import dayjs from "dayjs"
import TaskDynamicFormTypes from "../Types/TaskDynamicFormTypes"

const taskDynamicFormBoiler: TaskDynamicFormTypes = {
    DynamicFormWorkFlowId: null,
    CustomFormId: null,
    CustomFormDataId: null,
    PortalDynamicFormDistributionGroupId: null,
    PortalDynamicFormDistributionPointId: 3,
    FormDistributeTo: "Employee",
    DistributionPoint: "*",
    DistributionPointName: null,
    Value: null,
    DueDateUTC: null,
    CompletedDateUTC: null,
    CompletedBy: null,
    NeedsSupervisorApproval: false,
    SupervisorId: null,
    SupervisorApproved: null,
    SupervisorDateUTC: null,
    NeedsHRApproval: false,
    HRApproved: false,
    CreatedDateUTC: dayjs().format(),
    CreatedBy: null,
    ModifyDate: null,
    ModifiedBy: null,
    DeletedDateUTC: null,
    DeletedBy: null,
    DisabledDateUTC: null,
    DisabledBy: null,
}

export default taskDynamicFormBoiler